module.exports = __webpack_public_path__ + "media/images/save_and_close-1957b4f27314b7310b5cb6aa67a97f8a.png";